





















































































































import { Component, Vue } from 'vue-property-decorator'
import router from '@/router'
import '../../styles/buy.less'
import ChoiceTiem from './ChoiceTime.vue'
import ChoiceShops from './ChoiceShops.vue'
import ConfirmBuy from './ConfirmBuy.vue'
import ChoiceGoods from './ChoiceGoods.vue'

@Component({
  components: {
    ChoiceGoods,
    ChoiceTiem,
    ChoiceShops,
    ConfirmBuy
  }
})
export default class Buy extends Vue {
  private step: string = ''
  private stepStatus: string = '1'
  public created() {
    this.step = this.$route.query.step as string
    if (this.$route.query.tradeSize === 'PLATFORM' && this.$route.query.stepStatus === '1') {
      // 第一步开始 没有渠道
      this.stepStatus = '3'
    } else if (this.$route.query.tradeSize === 'STORE' && this.$route.query.stepStatus === '2') {
      // 第二步开始 有渠道
      this.stepStatus = '2'
    } else if (this.$route.query.tradeSize === 'PLATFORM' && this.$route.query.stepStatus === '2') {
      // 第二步开始 没有渠道
      this.stepStatus = '4'
    } else {
      this.stepStatus = '1'
    }
  }

  public beforeRouteUpdate(to: any, from: any, next: any) {
    if (to.query.step !== from.query.step) {
      this.step = to.query.step
    }
    next()
  }
}
